import { ManagerRole } from '~/constants/clientTypes';

export const consentToDataProcessing = [
  `Цим підтверджую, що ознайомлений з тим, що виконання Закону України "Про запобігання
                та протидію легалізації (відмиванню) доходів, одержаних злочинним шляхом,
                фінансуванню тероризму та фінансуванню розповсюдження зброї масового знищення" (далі
                – Закон) не є порушенням Закону України «Про захист персональних даних" в частині
                обробки персональних даних.`,
  `Обробка персональних даних відповідно до вимог Закону здійснюється без отримання
                необхідності згоди суб’єкта персональних даних. АТ «Укрексімбанк» (як суб’єкт
                первинного фінансового моніторингу) повідомив про покладений на нього обов’язок з
                обробки персональних даних для цілей запобігання та протидії легалізації
                (відмиванню) доходів, одержаних злочинним шляхом, фінансуванню тероризму та
                фінансуванню розповсюдження зброї масового знищення.`,
  `Також підтверджую, що фізичні особи, відомості стосовно яких надаватимуться,
                повідомлені про АТ "Укрексімбанк" як володільця відповідних персональних даних,
                склад та зміст зібраних персональних даних, їх права, визначені Законом України "Про
                захист персональних даних" та мету збору персональних даних.`,
];

export const MANAGER_PATH_PARTS = [
  '/covenants/manager',
  '/covenants/operator',
  '/covenants/covenants-branch-manager',
  '/covenants/uakdo-administrator',
] as const;

export const ROLE_ROUTES: Record<ManagerRole, string[]> = {
  [ManagerRole.call_center_operator]: ['/covenants/operator/get-started'],
  [ManagerRole.covenants_branch_manager]: [
    '/covenants/covenants-branch-manager/get-started',
  ],
  [ManagerRole.branch_manager]: ['/covenants/covenants-branch-manager/get-started'],
  [ManagerRole.uakdo_administrator]: [
    '/covenants/manager/applications',
    '/covenants/manager/applications/:applicationId',
    '/covenants/manager/segments',
    '/covenants/uakdo-administrator/get-started',
  ],
  [ManagerRole.manager]: [],
  [ManagerRole.observer]: [],
  [ManagerRole.personal_data_manager]: [],
};

export const SUPERVISOR_INFO_ROUTE_ACCESS = {
  '/covenants/manager/applications': 'hasApplicationAccess',
  '/covenants/manager/applications/:applicationId': 'hasApplicationAccess',
  '/covenants/uakdo-administrator/get-started': 'hasClientViewAccess',
  '/covenants/manager/email-blacklist': 'hasEmailBlackListAccess',
  '/covenants/contragents/:id/black-list': 'hasEmailBlackListAccess',
} as const;

export const MANAGER_USERNAME_COOKIE = 'manager_username';
export const USERNAME_COOKIE = 'username';
export const IS_AUTHENTICATED_KEY = 'isAuthenticated';
export const REFRESH_BEFORE_MS = 2 * 60 * 1000;
